<template lang='pug'>
  v-container.px-3.providers-container(fluid)
    //- Purchases provider
    v-dialog(v-if="showPurchasesDialog" v-model='showPurchasesDialog' max-width='800px' transition="dialog-bottom-transition")
      purchases-provider(@close="showPurchasesDialog = false; currentProvider=null" :provider="currentProvider")
    //- Create provider
    v-dialog(:fullscreen="isMobile" persistent  :value='createItemDialog'  max-width='800px'   transition="dialog-bottom-transition")
      create-item( @close="createItemDialog=false" v-if='createItemDialog' )
    //- Update provider
    v-dialog( persistent :key='currentItem.id' :value='updateItemDialog'  max-width='800px'   transition="dialog-bottom-transition")
      update-item(:model ='currentItem' v-if='updateItemDialog' @close="updateItemDialog=false")
    //- Delete provider
    v-dialog(v-model='confirmationDialog' width="500px" persistent)
      v-card(style="border: solid 1px;")
        v-card-title
          | Eliminar Proveedor
          v-spacer
          v-icon(aria-label="Close" @click="confirmationDialog = false")
            | mdi-close
        v-card-text.body-1.text-center
          | ¿Esta seguro de eliminar este proveedor?
        v-card-actions.text-center
          v-spacer
            v-btn(color='green darken-1', flat='', @click.native='confirmationDialog = false') No, cancelar
            v-btn(color='red darken-1', flat='', @click.native='deleteItem(currentItemId)') Si, proceder
    //- Content
    v-row.px-5.my-0
      v-card.rounded-lg.pa-3( width="100%")
        v-row
          v-col.pb-0(cols="12" xs="6" sm="6" md="4")
            v-card-title Proveedores
          v-col.pb-0.d-flex.create-btn(cols="12" xs="6" sm="6" md="8")
            v-btn.main-btn-gradient(small @click="createItemDialog=true" style="height: 48px;").mt-0
              v-icon mdi-plus
              | Agregar Proveedor
        v-row
          v-col(cols='12' md='12')
            .card-transactions
              .show-table-desktop
                v-data-table.elevation-0(:headers='headers', :items='Items', :items-per-page="5", :search='search')
                  //- template
                    v-card-text
                  template(v-slot:item.actions="{ item }")
                      v-btn(fab dark small text color='primary' @click.stop='openPurchases(item)')
                          v-icon(small) mdi-poll
                      v-btn(fab dark small text color='green' @click.stop='editItem(item.id)')
                          v-icon(small) mdi-pen
                      v-btn(fab dark small text color='red'  @click.stop='openDeleteDialog(item)')
                          v-icon(small) mdi-delete
              //- .show-table-mobile
                v-list(three-line="")
                  template(v-for="(item, index) in Items")
                    v-list-item(:key="item.id" @click="showItem(item)")
                      v-list-item-avatar
                        v-img(:src="getImage(item.pictures.imageInput1)" max-width="160px")
                      v-list-item-content
                        v-list-item-title(v-html="item.name")
                        v-list-item-subtitle(v-html="item.nit")
                    v-divider
                noResults(v-if="isMobile && Items.length === 0" :title="'No tienes proveedores'" :description="'En esta sección encontraras tus proveedores'")
    //- Old content
    //- v-layout(wrap='')
        <!-- content -->
        v-card(style='width:100%')
            v-card-title
              span Proveedores
              v-row
                v-col(:cols="isMobile ? '12' : '3'" :sm="isMobile ? '12' : '3'").text-right
                  v-card(style='margin: 2px;' flat link @click="createItemDialog=true" height="20" outlined).category-card.py-5.mx-2
                    v-layout(pa-1 pl-2).text-center
                      v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                        small.text-uppercase.text-center(style="width: 250px;") Añadir Proveedor
                          v-icon(large color="primary") mdi-plus
            <!-- list -->
            v-flex(md12='',)
                v-row
                    v-col
                        | Lista de Proveedores
                    v-col(v-if="!isMobile")
                        v-spacer
                            v-text-field(v-model='search', append-outer-icon='mdi-search', label='Buscar..', single-line='', hide-details='')
                v-card.mx-auto(v-if="isMobile && Items.length > 0" max-width="450")
                  v-list(three-line="")
                    template(v-for="(item, index) in Items")
                      v-list-item(:key="item.id" @click="showItem(item)")
                        v-list-item-avatar
                          v-img(:src="getImage(item.pictures.imageInput1)" max-width="160px")
                        v-list-item-content
                          v-list-item-title(v-html="item.name")
                          v-list-item-subtitle(v-html="item.nit")
                      v-divider
                noResults(v-if="isMobile && Items.length === 0" :title="'No tienes proveedores'" :description="'En esta sección encontraras tus proveedores'")
                v-data-table(v-if="!isMobile" :headers='headers', :items='Items', :items-per-page="5", :search='search')
                    template
                        v-card-text
                    template(v-slot:item.actions="{ item }")
                        v-btn(fab dark small color='green' @click.stop='editItem(item.id)')
                            v-icon(small) mdi-pen
                        v-btn(fab dark small color='red'  @click.stop='openDeleteDialog(item)')
                            v-icon(small) mdi-delete
</template>

<script>
  import loaders from '@/plugins/mixins/loaders'
  import CreateItem from './CreateProvider'
  import UpdateItem from './UpdateProvider'
  import userPlaceholder from '@/assets/user.png'
  import Swal from 'sweetalert2'
  // import logo from '@/assets/logo-2-w-small.png'

  export default {
    components: {
      CreateItem: CreateItem,
      UpdateItem: UpdateItem,
      PurchasesProvider: () => import('@/components/custom/dialogs/PurchasesProvidersDialog.vue'),
      noResults: () => import('@/components/custom/NoResults.vue'),
    },
    filters: {
    },
    mixins: [loaders],
    data () {
      return {
        userPlaceholder,
        currentItemId: null,
        createItemDialog: false,
        updateItemDialog: false,
        confirmationDialog: false,
        showPurchasesDialog: false,
        dialog: false,
        search: '',
        headers: [

          {
            sortable: true,
            text: 'Proveedor',
            value: 'name',
            align: 'left',
          },
          {
            sortable: true,
            text: 'NIT',
            value: 'nit',
            align: 'left',

          },
          {
            sortable: true,
            text: 'Nombre del vendedor',
            value: 'seller',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Telefono de Contacto',
            value: 'phone',
            align: 'left',

          },

          {
            sortable: false,
            text: 'Acciones',
            value: 'actions',
            align: 'left',

          },
        ],

        tabs: 0,
        list: {
          0: false,
          1: false,
          2: false,
        },
        currentProvider: null,
      }
    },
    computed: {
      currentItem () {
        // console.log(this.$store.getters['expenses/getCurrentItem'])
        return this.$store.getters['providers/getCurrentItem']
      },
      Items () {
        // console.log(this.$store.getters['providers/getItems'])
        return this.$store.getters['providers/getItems']
      },
      isMobile () {
        return window.innerWidth < 1024
      },
    },
    created () {
      const vm = this
      vm.fetch()
      vm.loadProviders()
    },
    methods: {
      getImage (url) {
        if (url === '') {
          return userPlaceholder
        } else {
          return url
        }
      },
      fetch () {
        const vm = this
        vm.$store.dispatch('providers/setCurrentItem', null)
      },
      showItem (item) {
        const vm = this
        vm.$router.replace('/dashboard/userDetails/provider')
        this.$store.dispatch('providers/setCurrentItem', { context: 'properties', id: item.id }).then(function () {
        })
      },

      editItem (id) {
        const vm = this
        this.$store.dispatch('providers/setCurrentItem', { context: 'properties', id: id }).then(function () {
          vm.updateItemDialog = true
        })
      },

      openDeleteDialog (item) {
        const vm = this
        vm.currentItemId = item
        Swal.fire({
          title: 'Eliminar proveedor',
          text: '¿Deseas continuar?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2ca0a5',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.isConfirmed) {
            vm.deleteItem(vm.currentItemId)
          }
        })
        /* vm.confirmationDialog = true
        vm.localLoad = true */
      },
      deleteItem (item) {
        // console.log(item)
        const vm = this
        this.$store.dispatch('providers/deleteItem', item).then(function () {
          vm.confirmationDialog = false
          vm.dialog = false
        },
        ).catch(function () {
          vm.confirmationDialog = false
          vm.dialog = false
        })
      },
      openPurchases (item) {
        const vm = this
        vm.currentProvider = item
        vm.showPurchasesDialog = true
      },
    },
  }
</script>
<style lang="scss">
  .providers-container{
    .create-btn{
      justify-content: center;
    }
    @media(min-width: 600px) {
      .create-btn{
        justify-content: end !important;
      }
    }
    .card-transactions{

      overflow-y: scroll !important;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    /* @media(min-width: 667px) {
      .show-table-mobile{
        display: none !important;
      }
      .show-table-desktop{
        display: block !important;
      }
    } */
    /* @media(max-width: 667px) {
      .show-table-mobile{
        display: flex !important;
      }
      .show-table-desktop{
        display: none !important;
      }
    } */
    .hover-cursor{
        cursor:pointer;
    }
    .shop {
      &__title {
        &--mobile {
          position: absolute;
          bottom: 0;
          left: 1rem;
          color: #009da5;
          font-size: 2rem;
          font-weight: bold;
          padding: 10px;
          text-shadow: 3px 1px black;
        }
      }
    }
  }
</style>
